{
  "messages": {
    "loading": "Chargement des messages...",
    "empty": "Aucun message pour le moment. Commencez la conversation !",
    "noEntitiesSelected": "Veuillez sélectionner des entités dans le menu déroulant ci-dessus pour voir les messages.",
    "counter": "Messages / {{count}}",
    "reply": "Répondre",
    "replyPlaceholder": "Écrivez une réponse...",
    "replyPlaceholderInternal": "Écrivez une réponse interne...",
    "replyPlaceholderClient": "Écrivez une réponse visible pour les clients...",
    "cancel": "Annuler",
    "send": "Envoyer",
    "important": "Important",
    "scrollToBottom": "Faire défiler vers le bas",
    "refresh": "Actualiser les messages",
    "newDivider": "Nouveau",
    "markRead": "Marquer comme lu",
    "markUnread": "Marquer comme non lu",
    "unknownAuthor": "Quelqu’un",
    "unreadCount": "{{count}} non lu(s)",
    "noMessages": "Aucun message",
    "messageCount": "{{count}} messages",
    "markedImportantBy": "! Marqué important par {{name}}"
  },
  "tabs": {
    "internal": "Interne",
    "client": "Client",
    "all": "Tout"
  },
  "visibility": {
    "client": "Client",
    "internal": "Interne"
  },
  "thread": {
    "reply": "réponse",
    "replies": "réponses"
  },
  "filters": {
    "relatedEntities": "Entités liées",
    "selectEntities": "Sélectionner des entités",
    "selectEntitiesDescription": "Voir les messages de plusieurs entités",
    "selectEntitiesPlaceholder": "Sélectionner des entités...",
    "all": "Tout",
    "current": "Actuel",
    "typesSelected": "{{count}} types sélectionnés",
    "important": "Important",
    "showImportant": "Afficher Important",
    "showImportantOnly": "Afficher uniquement les messages importants",
    "showAllMessages": "Afficher tous les messages",
    "allRelated": "Tous les liés",
    "someSelected": "{{count}} sélectionnés",
    "showUnread": "Non lus",
    "showUnreadOnly": "Afficher uniquement les messages non lus"
  },
  "input": {
    "placeholder": "Écrivez un message...",
    "placeholderAllTab": "Passez à l'onglet Interne ou Client pour envoyer des messages",
    "placeholderInternal": "Écrivez une mise à jour interne...",
    "placeholderClient": "Écrivez un message visible pour les clients...",
    "warningNote": "Note :",
    "warningMessage": "Sélectionnez l'entité actuelle ({{entityKey}}) pour envoyer des messages.",
    "pickAudience": "Choisissez Interne ou Client pour écrire — la vue combinée ne définit pas de destinataire.",
    "visibleInternal": "Visible par votre équipe seulement",
    "visibleClient": "Visible par le client"
  },
  "emoji": {
    "title": "Ajouter un emoji",
    "popoverTitle": "Insérer un emoji",
    "categories": {
      "Smileys": "Émoticônes",
      "Gestures": "Gestes",
      "Objects": "Objets",
      "Symbols": "Symboles"
    }
  },
  "tooltips": {
    "mentions": "@Mentions bientôt disponibles !",
    "attachments": "Pièces jointes bientôt disponibles !",
    "bold": "Gras",
    "italic": "Italique",
    "underline": "Souligné",
    "numberedList": "Liste numérotée",
    "bulletList": "Liste à puces",
    "link": "Lien",
    "showFormatting": "Afficher le formatage",
    "hideFormatting": "Masquer le formatage",
    "insertEmoji": "Insérer un emoji",
    "sendMessage": "Envoyer le message (Ctrl+Entrée)",
    "enterUrl": "Saisissez l'URL :",
    "addLink": "Ajouter un lien",
    "linkText": "Texte du lien",
    "markAsImportant": "Marquer comme important",
    "markAsNormal": "Retirer l'importance",
    "migrated": "Migré",
    "important": "Important",
    "markRead": "Marque ce message et tous les précédents comme lus.",
    "markUnread": "Marque ce message et tous les suivants comme non lus.",
    "importantLabel": "Important"
  },
  "time": {
    "justNow": "à l'instant",
    "minuteAgo": "il y a {{count}} minute",
    "minutesAgo": "il y a {{count}} minutes",
    "hourAgo": "il y a {{count}} heure",
    "hoursAgo": "il y a {{count}} heures",
    "dayAgo": "il y a {{count}} jour",
    "daysAgo": "il y a {{count}} jours",
    "monthAgo": "il y a {{count}} mois",
    "monthsAgo": "il y a {{count}} mois",
    "yearAgo": "il y a {{count}} an",
    "yearsAgo": "il y a {{count}} ans"
  },
  "accessibility": {
    "closeChatPanel": "Fermer le panneau de chat",
    "openChat": "Ouvrir le chat"
  },
  "subscription": {
    "join": "Rejoindre cette conversation",
    "leave": "Quitter cette conversation",
    "mute": "Ignorer",
    "unmute": "Réactiver",
    "muteTooltip": "Ne plus recevoir de notifications pour cette conversation. Vous conservez l'accès et pouvez l'ouvrir à tout moment.",
    "unmuteTooltip": "Recevoir de nouveau les notifications des nouveaux messages.",
    "resolving": "Notifications",
    "resolvingTooltip": "Vérification de votre paramètre de notification pour cette conversation…"
  },
  "participants": {
    "title": "Participants",
    "countLabel": "{{count}} dans cette conversation",
    "empty": "Personne n'a encore été ajouté à cette conversation.",
    "loading": "Chargement des personnes…",
    "loadFailed": "Impossible de charger les personnes de cette conversation.",
    "you": "Vous",
    "internal": "Interne",
    "client": "Client",
    "contextual": "À partir de cet enregistrement",
    "added": "Ajouté",
    "muted": "Ignoré",
    "addPeople": "Ajouter des personnes",
    "searchPlaceholder": "Rechercher par nom ou courriel…",
    "searching": "Recherche…",
    "noCandidates": "Plus personne à ajouter.",
    "noCandidatesForClient": "Seules les personnes déjà liées à cet enregistrement peuvent être réintégrées.",
    "previouslyLeft": "Était déjà dans cette conversation",
    "add": "Réactiver",
    "remove": "Ignorer",
    "removeSelf": "Ignorer",
    "removeTooltip": "Arrête ses notifications. L'accès est conservé : cette conversation reste consultable depuis le dossier.",
    "removeSelfTooltip": "Arrête vos notifications. Vous conservez l'accès et pouvez toujours ouvrir cette conversation depuis le dossier.",
    "addTooltip": "Cette personne sera de nouveau notifiée des nouveaux messages.",
    "changeFailed": "Impossible de modifier cette personne. Veuillez réessayer.",
    "entityTitle": "Participants — {{entity}}",
    "invitee": "Invité",
    "addShort": "Ajouter",
    "addBarTooltip": "Ajoutez une personne pour qu'elle soit notifiée des nouveaux messages. Cela ne change pas qui peut voir cette conversation.",
    "countLabelWithMuted": "{{count}} dans cette conversation · {{muted}} ignoré(s)",
    "participation": {
      "added": "Ajouté le {{at}}",
      "removed": "Retiré le {{at}}",
      "joined": "A rejoint le {{at}}",
      "left": "A quitté le {{at}}"
    }
  }
}
